import { saveWallpaper } from '../services/settingsService';
import { showErrorToast, showSucessToast } from '../channels/utils';
import { WALLPAPER_DEFAULT_COLOR } from '../Helpers/Constants';
import logger from '../Helpers/logger';
import {
    RESET_WALLPAPER_COLOR,
    SET_WALLPAPER_COLOR,
    SET_WALLPAPER_PREVIEW_COLOR,
    WALLPAPER_PREVIEW_SECTION,
} from './Constants';

/**
 * Show wallpaper preview section
 * @param {boolean} previewSection - The color code to set
 */
export const wallpaperPreviewSection = previewSection => {
    return {
        type: WALLPAPER_PREVIEW_SECTION,
        payload: {
            previewSection,
        },
    };
};

/**
 * Action to set wallpaper preview color
 * @param {string} previewColor - The color code to set
 */
export const setWallpaperPreviewColor = previewColor => {
    return {
        type: SET_WALLPAPER_PREVIEW_COLOR,
        payload: {
            previewColor,
        },
    };
};

/**
 * Action to set wallpaper color
 * @param {string} color - The color code to set
 */
export const setWallpaperColor = color => {
    return async (dispatch, _getState) => {
        try {
            const colorToUse = color || WALLPAPER_DEFAULT_COLOR;
            // Make API call
            await saveWallpaper(colorToUse);
            showSucessToast('Wallpaper applied successfully');

            // Update Redux state first (optimistic update)
            dispatch({
                type: SET_WALLPAPER_COLOR,
                payload: { color: colorToUse },
            });
        } catch (error) {
            showErrorToast('Failed to apply wallpaper. Please try again.');
            logger.error('Failed to set wallpaper color:', error);
        }
    };
};

/**
 * Action to reset wallpaper to default (transparent)
 */
export const resetWallpaperColor = () => {
    return async (dispatch, _getState) => {
        try {
            const colorToUse = WALLPAPER_DEFAULT_COLOR;

            // Make API call
            await saveWallpaper(colorToUse);
            showSucessToast('Wallpaper applied successfully');

            // Update Redux state first
            dispatch({
                type: RESET_WALLPAPER_COLOR,
                payload: { color: colorToUse },
            });
        } catch (error) {
            showErrorToast('Failed to apply wallpaper. Please try again.');
            logger.error('Failed to reset wallpaper color:', error);
        }
    };
};

/**
 * Action to initialize wallpaper color from localStorage
 */
export const initializeWallpaperColor = color => {
    return async (dispatch, _getState) => {
        try {
            const colorToUse = color || WALLPAPER_DEFAULT_COLOR;

            // Update Redux state
            dispatch({
                type: SET_WALLPAPER_COLOR,
                payload: { color: colorToUse },
            });
        } catch (error) {
            logger.error('Failed to initialize wallpaper color:', error);
        }
    };
};
